import { render, staticRenderFns } from "./ProdesPantanal.vue?vue&type=template&id=75e35bae&lang=pug"
import script from "./ProdesPantanal.vue?vue&type=script&lang=js"
export * from "./ProdesPantanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports